export enum AnalyticsTabType {
  UGC = 'ugc',
  TAG = 'tag',
  TREND = 'trend',
  HASHTAG = 'hashtag',
  COMPARE = 'compare',
  DASHBOARD = 'dashboard',
  INTERACTION = 'interaction'
}
